<template>
  <CCard>
    <CCardHeader class="d-flex justify-content-between align-items-center">
      سوالات

    </CCardHeader>
    <CCardBody class="d-flex align-items-center text-center h-100">
      <CDataTable
          :fields="fields"
          :items="questions"
          :loading="loading"
          :noItemsView="{
          noItems: 'در حال حاضر محتوایی در این قسمت وجود ندارد',
        }"
          border
          class="w-100 d-flex justify-content-between h-100"
          fixed
          hover
          small
          striped
      >

        <template #text="{ item }">
          <td>
            <div v-if="item.text.length > 30">
              {{ item.text.slice(0, 30) }}...
            </div>
            <div v-else>{{ item.text }}</div>
          </td>
        </template>
        <template #p="{ item }">
          <td class="ltr">
            <div :class="{'danger': (item.p < 0.3 || item.p > 0.7)}">
              {{ item.p }}
            </div>

          </td>
        </template>
        <template #v="{ item }">
          <td class="ltr">
            {{ item.v }}
          </td>
        </template>
        <template #d="{ item }">
          <td class="ltr">
            <div :class="{'danger': (item.d < 0)}">
              {{ item.d }}
            </div>
          </td>
        </template>
        <template #viewQuestion="{ item }">
          <td>
            <CButton class="modal-button" size="sm" square @click="onViewExamQuestionModal(item)">
              مشاهده
            </CButton>
          </td>
        </template>
      </CDataTable>
      <ViewExamQuestionModal v-model="viewExamQuestionModal" :question="selectedItem"/>
    </CCardBody>
  </CCard>
</template>

<script>

import ViewExamQuestionModal from "../Modals/Exam/ViewExamQuestionModal";

export default {
  name: 'FinishedExamQuestionTable',
  components: {ViewExamQuestionModal},
  props: {
    questions: {
      type: Array,
    },
  },

  data() {
    return {
      loading: false,
      fields: [
        {
          key: "text",
          label: "تیتر سوال",
        },
        {key: "p", label: "ضریب دشواری"},
        {key: "v", label: "واریانس"},
        {key: "d", label: "ضریب تمیز"},
        {key: "mark", label: "بارم"},
        {key: "viewQuestion", label: "مشاهده"},
      ],
      viewExamQuestionModal: false,
      selectedItem: {},
    };
  },
  methods: {
    getQuestions() {
      this.$emit("get-questions");
    },
    onViewExamQuestionModal(item) {
      this.selectedItem = item
      this.viewExamQuestionModal = true
    }
  },
};
</script>

<style lang="scss" scoped></style>